export const handleQuestionsInitialAdjustments = (
  questionnaire,
  isFramework,
  isClaims,
  currentPeriod,
  isThirdParty
) => {
  questionnaire = isFramework ? questionnaire.filter(q => q.idQuestion != 391) : questionnaire.filter(q => ![178, 179, 180].includes(q.idQuestion));

  questionnaire.map(question => {
    if (!question?.idAnswerOption && question.idDomainQuestion == 43 && question.answer) {
      if (question.answer.includes("idAnswerOption")) {
        let answerJson = JSON.parse(question.answer || {});
        question.idAnswerOption = answerJson?.idAnswerOption ?? null
      } else if (question.answerOptions) {
        let answerOption = question.answerOptions.find(answerOpt => answerOpt.dsAnswerOption == question.answer)?.idAnswerOption;
        question.idAnswerOption = answerOption;
      }
    }

    if (question.idQuestion == 391) {
      question.behaviorObject.isRequired = isClaims ?? false;
      if (question.answer) {
        question.answer = question.answerJson;
      }
    }

    if ([141, 753, 1808].includes(question.idQuestion)) {
      question.disabled = isFramework || isClaims || false;
    }

    if ([1824].includes(question.idQuestion)) {
      question.visibleQuestion = isThirdParty
    }

    if (question.idQuestion == 753) {
      if ((question.answer === '' && currentPeriod === 1) || question.answer === 'Yes') {
        question.answer = "Yes";
        question.idAnswerOption = 5014;
      }
    }

    if ([141, 142, 753].includes(question.idQuestion)) {
      question.behaviorObject.isRequired = (question.behaviorObject.isRequired && !isFramework) ?? false;
    }

    if (question.idQuestion == 140) {
      question.answerOptions = question.answerOptions.filter(answerOpt => isFramework ? answerOpt.idAnswerOption == 2264 : isClaims ? answerOpt.idAnswerOption == 1026 : answerOpt.idAnswerOption != 2264);
    }
    return question;
  })
  return questionnaire;
}


export const handleQuestionChange = (
  question,
  value,
  filteredQuestionnaire,
  setFilteredQuestionnaire,
  setFieldValue,
) => {
  let saveFilteredQuestionnaire = false;

  if (question.idQuestion === 140) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion == 141) {
        if (idAnswerOption == 1027) {
          qst.answer = "Yes";
          qst.answerJson = "Yes"
          qst.idAnswerOption = 1024;
          const result = { idAnswerOption: qst.idAnswerOption, dsAnswerOption: qst.answer, resultValue: null }
          setFieldValue && setFieldValue(qst.key, result);

        }
      }

      return qst;
    })

  }

  if (question.idQuestion == 141) {
    saveFilteredQuestionnaire = true;
    const isDirectInsurerPayment = filteredQuestionnaire.find(q => q.idQuestion == 140)?.idAnswerOption == 1027;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion == 141) {
        if (isDirectInsurerPayment) {
          qst.answer = "Yes";
          qst.answerJson = "Yes";
          qst.idAnswerOption = 1024;
          const result = { idAnswerOption: qst.idAnswerOption, dsAnswerOption: qst.answer, resultValue: null }

          setFieldValue && setFieldValue(qst.key, result);
        }
      }
      return qst;
    })
  }

  if (saveFilteredQuestionnaire) setFilteredQuestionnaire(filteredQuestionnaire);
}






